import { GroupType } from "../types/group.type";
import { formatDateDisplay, numeralCustom } from "./helpers";
import FilterCRThuoc from "../components/common/filter/group/crthuoc/FilterCRThuoc";
import moment from "moment";

const groups: { [key: string]: GroupType } = {
  cr_thuoc: {
    title: "Báo cáo giá thuốc trúng thầu",
    apiCode: "fos_tonghopgiacr",
    fastFields: [],
    Filter: FilterCRThuoc,
    generateCondition: (filter) => {
      const condition: { [key: string]: any } = {};
      if (filter.ten_thuoc) {
        condition.ten_thuoc = filter.ten_thuoc;
      }
      if (filter.hoat_chat) {
        condition.hoat_chat = filter.hoat_chat;
      }
      if (filter.hamluong) {
        condition.hamluong = filter.hamluong;
      }
      if (filter.gdklh) {
        condition.gdklh = filter.gdklh;
      }
      if (filter.duongdung) {
        condition.duongdung = filter.duongdung;
      }
      if (filter.baoche) {
        condition.baoche = filter.baoche;
      }
      if (filter.nhomthuoc) {
        condition.nhomthuoc = filter.nhomthuoc;
      }
      if (filter.cssx) {
        condition.cssx = filter.cssx;
      }
      if (filter.nuocsx) {
        condition.nuocsx = filter.nuocsx;
      }
      if (filter.quycach) {
        condition.quycach = filter.quycach;
      }
      if (filter.dvt) {
        condition.dvt = filter.dvt;
      }
      if (filter.tbmt) {
        condition.tbmt = filter.tbmt;
      }
      if (filter.cdt) {
        condition.cdt = filter.cdt;
      }
      if (filter.soquyetdinh) {
        condition.soquyetdinh = filter.soquyetdinh;
      }
      if (filter.slnhathau) {
        condition.slnhathau = filter.slnhathau;
      }
      if (filter.diadiem) {
        condition.diadiem = filter.diadiem;
      }
      if (filter.ngayquyetdinhFrom || filter.ngayquyetdinhTo) {
        const startDate = moment(filter.ngayquyetdinhFrom)
          .hours(0)
          .minutes(0)
          .seconds(0);
        const endDate = moment(filter.ngayquyetdinhTo)
          .hours(23)
          .minutes(59)
          .seconds(59);
        if (filter.ngayquyetdinhFrom && filter.ngayquyetdinhTo) {
          condition.ngayquyetdinh = { $gte: startDate, $lte: endDate };
        } else if (filter.timeFrom) {
          condition.ngayquyetdinh = { $gte: startDate };
        } else if (filter.timeTo) {
          condition.ngayquyetdinh = { $lte: endDate };
        }
      }
      return condition;
    },
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thuốc",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_thuoc,
      },
      {
        name: "Đơn giá",
        width: "130px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) => numeralCustom(row.dongia).format(),
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hoat_chat,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hamluong,
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.gdklh,
      },
      {
        name: "Đường dùng",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.duongdung,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.baoche,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhomthuoc,
      },
      {
        name: "Cơ sở SX",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cssx,
      },
      {
        name: "Nước SX",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nuocsx,
      },
      {
        name: "Quy cách",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.quycach,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Số lượng",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "210px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soquyetdinh,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayquyetdinh,
        format: (row) => formatDateDisplay(row.ngayquyetdinh, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
        format: (row) => numeralCustom(row.slnhathau).format(),
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
};

export { groups };
